import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SearchBar from '../datatable/SearchBar';
import DataTable from '../datatable/DataTable';
import SectionCreateModal from '../../modal/section/SectionCreateModal';
import SectionEditModal from '../../modal/section/SectionEditModal';
import SectionDuplicateModal from '../../modal/duplicate/SectionDuplicateModal';
import Alert from '../../modal/alert/Alert';
import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';
import {
  listSection,
  deleteSection,
  clearErrorSection,
} from '../../redux/section/section_actions';

class SectionDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const float2 = getColumnStyle(COLUMN_STYLE.float2);

    const { t } = props;

    this.columns = [
      {
        id: 'name',
        Header: () => <b>{t('name')}</b>,
        accessor: item => ({ name: item.name, id: item.id }),
        Cell: row => <Link to={`/sections/${row.value.id}`}>{row.value.name}</Link>,
        ...textColumn,
      },
      {
        Header: () => <b>{t('envelop')}</b>,
        accessor: 'envelop_name',
        ...textColumn,
      },
      {
        Header: () => <b>{`${t('area')} (${t('sq m')})`}</b>,
        accessor: 'area',
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('WWR')}</b>,
        accessor: 'WWR',
        ...float2,
      },
    ];

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true  });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true  });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listSection(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      selectedInstance: item,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      errorMessage,
      building,
      t,
    } = this.props;

    return (
      <div>
        <SectionCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
          building={building}
        />
        <SectionEditModal
          section={item}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
          building={building}
        />
        <SectionDuplicateModal
          item={item}
          show={isShowDuplicateModal}
          title={t('copy section')}
          label={t('new section name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete section')}
          body={`${t('do you want to delete')} ${item ? item.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteSection(item)}
        />
        <SearchBar
          onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)}
          auxiliaryButton={<Button bsStyle="success" onClick={() => this.setState({ isShowCreateModal: true, isCreated: false  })}>{t('create')}</Button>}
        />
        <DataTable
          columns={this.columns}
          data={this.props.sections}
          onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original, isEdited: false  })}
          onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original, isDuplicated: false })}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sections: state.section.orderedIds.map(id => state.section.objects[id]),
  filteredCount: state.section.filteredCount,
  isLoading: state.section.isLoading,
  isCreating: state.section.isCreating,
  isEditing: state.section.isEditing,
  isDeleting: state.section.isDeleting,
  isDuplicating: state.section.isDuplicating,
  errorMessage: state.section.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listSection: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listSection(pageSize, page, sorted, filtered, isPublic, props.building.id)),
    ),
  deleteSection: ({ id }) => defaultRejectHandler(dispatch(deleteSection(id))),
  clearError: () => dispatch(clearErrorSection()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SectionDataTable),
);



// WEBPACK FOOTER //
// ./src/components/section/SectionDataTable.js